import React from "react";
import { Box, Button, Grid, LinearProgress } from "@material-ui/core";
import UserAutoComplete from "../../../Form/UserAutoComplete";
import TextFieldHelper from "../../../UI/FormHelper/TextFieldHelper";
import FieldDatePicker from "../../../Form/FieldDatePicker";
import Wrapper from "../../../../hoc/Wrapper/Wrapper";
import momentJalali from "moment-jalaali";

const ChequeContractStep3FormFields = (props) => {
  const {
    values,
    touched,
    handleChange,
    isValid,
    setFieldTouched,
    setFieldValue,
    handleClose,
    handleSubmit,
    errors,
  } = props;

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Grid container>
          <Grid item xs={12} md={6}>
            <Box p={1}>
              <UserAutoComplete
                title={"نفر اول قرارداد"}
                fieldName={"first_party_id"}
                fieldNameShow={"first_party_fullname"}
                setFieldValue={setFieldValue}
                value={values.first_party_fullname}
                touched={touched["first_party_id"]}
                errors={errors["first_party_id"]}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <UserAutoComplete
                title={"نفر دوم قرارداد"}
                fieldName={"second_party_id"}
                fieldNameShow={"second_party_fullname"}
                setFieldValue={setFieldValue}
                value={values.second_party_fullname}
                touched={touched["second_party_id"]}
                errors={errors["second_party_id"]}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <FieldDatePicker
                label={"تاریخ قرارداد"}
                fieldName={"agreement_date"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"درصد توافق"}
                fieldName={"ratio"}
                disabled={true}
                {...props}
                values={{
                  ratio: props.percent,
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"تاریخ مبدا"}
                fieldName={"origin_date"}
                disabled={true}
                {...props}
                values={{
                  origin_date: momentJalali(props.originDate).format(
                    "jYYYY/jMM/jDD",
                  ),
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box p={1}>
              <TextFieldHelper
                title={"توضیحات"}
                fieldName={"description"}
                multiline={true}
                {...props}
              />
            </Box>
          </Grid>

          {props.isEdit ? (
            <Wrapper>
              <Grid item xs={12} md={6}>
                <Box p={1}>
                  <TextFieldHelper
                    title={"تاریخ ویرایش"}
                    fieldName={"updated_at"}
                    {...props}
                    disabled={true}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box p={1}>
                  <TextFieldHelper
                    title={"تاریخ ثبت"}
                    fieldName={"created_at"}
                    disabled={true}
                    {...props}
                  />
                </Box>
              </Grid>
            </Wrapper>
          ) : null}
        </Grid>

        <Box mt={2}>
          {props.loading ? (
            <Wrapper>
              <Button color={"default"}></Button>
              <LinearProgress />
            </Wrapper>
          ) : (
            <Button
              variant={"contained"}
              type="submit"
              size={"large"}
              fullWidth={true}
              color={"primary"}
              disabled={!isValid}
            >
              {props.isEdit ? "ویرایش قرارداد" : "افزودن قرارداد"}
            </Button>
          )}
        </Box>
      </form>
    </div>
  );
};

export default ChequeContractStep3FormFields;
